import { AnalysisAutomationItem } from 'modules/analyse/types/AutomationTasks';
import { AutomationTaskActions } from './formatAutomationTasksForSubmission';
import { findParentAutomationTaskId } from './findParentAutomationTaskId';

type GetUpdateCandidateBatchGroupComponentsInputProps = {
  initialAutomationTasks: AnalysisAutomationItem[];
  candidateBatchGroupId: string;
  automationTasksActions: AutomationTaskActions;
  overwriteLockedCandidates: boolean;
  saveOnly: boolean;
};

export const getUpdateCandidateBatchGroupComponentsInput = ({
  initialAutomationTasks,
  candidateBatchGroupId,
  automationTasksActions,
  overwriteLockedCandidates,
  saveOnly
}: GetUpdateCandidateBatchGroupComponentsInputProps) => {
  const {
    automationTasksToCreate,
    automationTasksToDelete,
    automationTasksToUpdate
  } = automationTasksActions;

  const getAutomationTaskParent = (id: string): string => {
    const parentId = findParentAutomationTaskId(
      id,
      initialAutomationTasks || []
    );

    if (!parentId) {
      throw new Error('Parent id not found');
    }

    return parentId;
  };

  return {
    candidateBatchGroupId,
    parentAnalysisAutomationTasksToAdd: automationTasksToCreate,
    parentAnalysisAutomationTasksToDelete: automationTasksToDelete.map((id) =>
      getAutomationTaskParent(id)
    ),
    parentAnalysisAutomationTasksToUpdate: automationTasksToUpdate.map(
      (task) => {
        return {
          ...task,
          id: getAutomationTaskParent(task.id)
        };
      }
    ),
    overwriteLockedCandidates,
    skipPastCandidatesUpdate: saveOnly
  };
};
